import { accDiv, accMul } from "./utils";
import store from '@/store'
import ConstConfig from "@/config/ConstConfig"

/**通过货币代码获取货币符号 */
export function convertCurrency() {
  if (getCurrency() == ConstConfig.CURRENCY_CONFIG.BRL) {
      return ConstConfig.CURRENCY_CONFIG.BRL_SIGN;
  } else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.NGN) {
      return ConstConfig.CURRENCY_CONFIG.NGN_SIGN;
  } else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.IDR) {
    return ConstConfig.CURRENCY_CONFIG.IDR_SIGN;
  } else if (getCurrency() === ConstConfig.CURRENCY_CONFIG.PHP) {
    return ConstConfig.CURRENCY_CONFIG.PHP_SIGN;
  }else if (getCurrency() === ConstConfig.CURRENCY_CONFIG.MXN) {
    return ConstConfig.CURRENCY_CONFIG.MXN_SIGN;
  }
  return "";
}

/**
 * 转换金额
 * @param gold 金额,以分为单位
 * @param fixed 保留小数点位数
 */
export function changeMoney (gold,fixed) {
  if (getCurrency() === ConstConfig.CURRENCY_CONFIG.BRL) {  //巴西货币(雷尔)
    return changeMoneyByBRL(gold,fixed);
  } else if (getCurrency() === ConstConfig.CURRENCY_CONFIG.NGN) { //尼日利亚(奈拉)
    return changeMoneyByNGN(gold);
  } else if (getCurrency() === ConstConfig.CURRENCY_CONFIG.IDR) {  //印尼(卢比)
    return changeMoneyByID(gold);
  }else if (getCurrency() === ConstConfig.CURRENCY_CONFIG.PHP) {  //菲律宾比索
    return changeMoneyByPhp(gold,fixed);
  }else if (getCurrency() === ConstConfig.CURRENCY_CONFIG.MXN) {  //菲律宾比索
    return changeMoneyByBRL(gold,fixed);
  }
  return "";
};

/**获取带单位的金额 */
export function getGold(gold,fixed) {
    let tempGold = convertCurrency();
    if (tempGold) {
      tempGold = tempGold + changeMoney(gold,fixed);
    } else {
      return "";
    }
    return tempGold;
}

/**
 * 获取转换后的金额 不带符号
 * */
export function changeAmount(amount) {
  if (getCurrency() == ConstConfig.CURRENCY_CONFIG.BRL) {  //巴西货币(雷尔)
    return accDiv(amount, 100);
  }if (getCurrency() == ConstConfig.CURRENCY_CONFIG.PHP) {  //菲律宾
    return accDiv(amount, 100);
  } else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.NGN) { //尼日利亚(奈拉)
    return amount;
  } else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.IDR) { //印尼(卢比)
    return amount;
  }else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.MXN) { //印尼(卢比)
    return accDiv(amount, 100);
  }
  return accDiv(amount, 100);
}

/**获取金额配置的下标 */
export function getAmountIndex() {
  if (getCurrency() == ConstConfig.CURRENCY_CONFIG.BRL) {
      return 0;
  } else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.NGN) {
      return 1;
  } else if (getCurrency() == ConstConfig.CURRENCY_CONFIG.IDR) {
    return 2;
  }
  return 0;
}

/**获取当前货币型号 */
function getCurrency() {
  if (store.state.currency) {
    return store.state.currency;
  } else {
    let gameConfig = localStorage.getItem(ConstConfig.LOCAL_CONST.GAME_CONFIG);
    if (gameConfig && gameConfig.currency) {
      return gameConfig.currency;
    }
  }
  return "";
}

/**转换货币 巴西 雷亚尔 */
function changeMoneyByBRL(gold,fixed) {
  let tempMoney = ""+gold;
  tempMoney = accDiv(gold, 100).toFixed(!fixed && fixed !==0?2:fixed);
  // console.log("fixed",!!fixed,tempMoney,!0)
  tempMoney = tempMoney.replace(".", ",");
  return tempMoney.replace(/\d+/, function (m) {
    return m.replace(/(?=(\B)(\d{3})+$)/g, ".");
  });
}

/**转换货币 尼日利亚 奈拉*/
function changeMoneyByNGN(gold) {
  let tempMoney = ""+gold;
  return tempMoney.replace(/\d+/, function (m) {
    return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
  });
}
/**转换货币 菲律宾 比索*/
function changeMoneyByPhp(gold,fixed=2) {
    let tempMoney = ""+gold;
    tempMoney = ""+accDiv(gold, 100).toFixed(fixed);
    return tempMoney.replace(/\d+/, function (m) {
        return m.replace(/(?=(\B)(\d{3})+$)/g, ",");
    });
}

/**转换货币 印尼 卢比*/
function changeMoneyByID(gold) {
  let tempMoney = ""+accMul(gold, 10);
  let m = tempMoney.replace(/\d+/, function (m) {
    return m.replace(/(?=(\B)(\d{3})+$)/g, ".");
  });
  if (Number(tempMoney) >= 100000000) {
    m = m.substring(0, m.length - 8) + ",00jt";
  } else if (Number(tempMoney) >= 1000000) {
    //rb
    m = m.substring(0, m.length - 4) + ",00k";
  }
  return m;
}


export function AddH5() {
  const H5AddClassName = "App-H5";
    const appNode = document.getElementById("app");
    appNode.classList.add(H5AddClassName);
}

/**
 * 传入毫秒时间戳，返回格式化时间
 */
export function getFTime(times) {
  const date =  new Date(times);
  // 使用 Intl.DateTimeFormat 获取墨西哥时间
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Mexico_City',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false  // 24小时制
  })

  // 获取各个部分
  const parts = formatter.formatToParts(date)
  const partObj = {}
  parts.forEach(part => {
    partObj[part.type] = part.value
  })
  // 组装为 YYYY-MM-DD HH:mm:ss 格式
  return `${partObj.year}-${partObj.month}-${partObj.day} ${partObj.hour}:${partObj.minute}:${partObj.second}`
}

export default {
    convertCurrency,
    changeMoney,
    getGold,
    getAmountIndex,
    AddH5,
  getFTime,
}
